// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1331":"8449c68f","1593":"6ba056f9","1812":"8742717b","2830":"8449c68f","3278":"8b5df740","8719":"c8548b8a"}[chunkId] + ".chunk.css";
};